import React, { useEffect, useRef, useState } from 'react'
import { emptySpace } from '../../index.js';
import emailjs from '@emailjs/browser';
import HeroSection from '../../components/Herosection/HeroSection.jsx';
import './kontaktpage.scss';

const defaultStatus = '';
const maxMessageLength = 500;

const Kontaktpage = () => {
  const [currentHeroSectionHeight, setCurrentHeroSectionHeight] = useState(0);
	const [statusMessage, setStatusMessage] = useState(emptySpace);
	const [submitStatus, setSubmitStatus] = useState(defaultStatus);
	const [messageLength, setMessageLength] = useState(maxMessageLength);
	const [formData, setFormData] = useState({ name: '', discordName: '', email: '', subject: '', message: '' });

  // const noNumbersRegex = /^[^\d]*$/;
  
  const formRef = useRef();
  const nameInputRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'email' ? value.toLowerCase() : value,
    });
  };

  useEffect(() => {
		const validEmailRegex = /\.[a-zA-Z]{2,3}$/;
    
		let message = emptySpace;
    let status = defaultStatus;
    if (formData.email.length > 6) {
      if (!formData.email.includes('@') || !validEmailRegex.test(formData.email)) {
        message = 'Ungültiges E-Mail Format!';
        status = 'error';
      }
    }
    setStatusMessage(message);
    setSubmitStatus(status);
  }, [formData.email]);

	useEffect(() => {
		const noNumbersRegex = /^[^\d]*$/;
		
		let message = emptySpace;
		let status = defaultStatus;

		if (formData.name.length > 3) {
			if (!noNumbersRegex.test(formData.name) && formData.name.length > 2) {
				message = 'Dieses Feld erlaubt keine Zahlen!';
				status = 'error';
			}
		}

		setStatusMessage(message);
    setSubmitStatus(status);
	}, [formData.name])

  useEffect(() => {
    setMessageLength(maxMessageLength - (formData.message?.length || 0));
  }, [formData.message]);
    
  const handleSubmit = (e) => {
    e.preventDefault();

    if (Object.values(formData).some(value => value.trim() === '')) {
      setStatusMessage('Alle Felder müssen ausgefüllt werden!');
      setSubmitStatus('error');
      return;
    }
    sendMail(e);
  };

  const sendMail = (e) => {
    emailjs.sendForm('service_8i95zrf', 'template_urtk3hw', formRef.current, {
      publicKey: 'DffPYFneFM5r3s5R8',
    }).then(() => {
      setStatusMessage('Deine Nachricht wurde erfolgreich versendet.');
      setSubmitStatus('success');
      setTimeout(clearInputs, 3000);
    }, () => {
      setStatusMessage('Entschuldigung! Etwas ist schief gelaufen.');
      setSubmitStatus('error');
    });
  };

  function clearInputs() {
    if (formRef.current) {
      formRef.current.reset();
    };
		nameInputRef.current.classList.remove('error-outline');
    setFormData({
				name: '',
				discordName: '',
				email: '',
				subject: '',
				message: ''
			});
  };

  useEffect(() => {
    const updateHeight = () => {
      const heroElement = document.querySelector('.hero-section');
      if (heroElement) {
        setCurrentHeroSectionHeight(heroElement.offsetHeight);
      }
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

	return (
		<div className='main-wrapper kontaktpage-wrapper'>
			<HeroSection name={"KONTAKT"} />
			<div className='section-wrapper'>
				<div className='section section-left' style={{maxHeight: `calc(100dvh - ${currentHeroSectionHeight}px - 40px)`}}>
					<h2>Unsere Kontaktdaten</h2>
					<div className='contact-container'>
						<i className="bi bi-envelope-at"></i>
						<hr />
						<div className='contact-info-wrapper'>
							<p>Support Mail:</p>
							<a className='link' href='mailto:mail@nexark.de' rel='noopener noreferrer' target='_blank'>mail@nexark.de</a>
						</div>
					</div>
					<div className='contact-container'>
						<i className="bi bi-discord"></i>
						<hr />
						<div className='contact-info-wrapper'>
							<p>Unser Discord:</p>
							<a className='link' href='https://discord.gg/E5gPRwfvWS' rel='noopener noreferrer' target='_blank'>NEXARK</a>
						</div>
					</div>
				</div>
				<div className='section section-right' style={{minHeight: `calc(100dvh - ${currentHeroSectionHeight}px - 40px)`}}>
					<h2>Schreib uns eine Nachricht!</h2>
					<div className='status-message-wrapper' style={{
            outline: submitStatus === 'success' ? '1px solid green' : submitStatus === 'error' ? '1px solid red' : 'none',
            background: submitStatus === 'success' ? '#37b33dda' : submitStatus === 'error' ? '#b33737' : 'none'
          }}>
            <p>{statusMessage}</p>
          </div>
					<form ref={formRef} onSubmit={handleSubmit}>
						<div className="form-row">
							<input type='text' name='name' ref={nameInputRef} onChange={handleChange} value={formData.name} placeholder='Name [a-Z]' minLength={3} required tabIndex={0} />
							<input type="text" name="discordName" id="discordName" placeholder='Dein Discord Name' required onChange={handleChange} value={formData.discordName}/>
						</div>
						<div className="form-row">
							<input type="email" name="email" id="email" onChange={handleChange} value={formData.email} placeholder='Deine E-Mail' required/>
							<select name="subject" id="subject" required onChange={handleChange} value={formData.subject}>
								<option value="" disabled>Betreff auswählen..</option>
								<option value="Support">❗ Support / Itemverlust / Dinoverlust</option>
								<option value="Feedback">📢 Feedback / Lob / Kritik</option>
								<option value="Sonstiges">❓ Sonstiges / Allgemeine Frage</option>
							</select>
						</div>
						<div className='form-row'>
              <textarea name='message' onChange={handleChange} value={formData.message} placeholder='Deine Nachricht (500 Zeichen)' maxLength={500} rows={9} required spellCheck={false} ></textarea>
              {(messageLength < 500 && messageLength >= 0) &&
								<span className='message-length'>{messageLength < 500 && messageLength > 0 ? `(${messageLength} Zeichen übrig)` : '(Keine Zeichen mehr übrig)'}</span>
							}
            </div>
						<button type="submit">Absenden</button>
					</form>
				</div>
			</div>
		</div>
	)
}

export default Kontaktpage